import axios, { AxiosRequestConfig } from "axios";
import { webAPI } from "../../api/Api";

export default {
  getCustomDictionaries(request, config) {
    return axios.post("Nsi/Dictionary/Groupped", request, config);
  },

  saveGroup(data) {
    if (data.id) return axios.put("Nsi/Dictionary/Group", data);
    else return axios.post("Nsi/Dictionary/Group", data);
  },

  saveDict(data) {
    if (data.id) return axios.put("Nsi/Dictionary", data);
    else return axios.post("Nsi/Dictionary", data);
  },

  saveDictItem(data) {
    if (data.id) return axios.put("Nsi/Dictionary/Items", [data]);
    else return axios.post("Nsi/Dictionary/Items", [data]);
  },

  fillDictItems(dictId, values) {
    debugger;
    return axios.post(`/Nsi/Dictionary/Items/${dictId}/Upload`, values);
  },

  deleteGroup(id) {
    return axios.delete(`Nsi/Dictionary/Group/${id}`);
  },

  deleteDict(id) {
    return axios.delete(`Nsi/Dictionary/${id}`);
  },

  lockDictionary(dictionaryId) {
    return axios.post(`Nsi/Dictionary/${dictionaryId}/Lock`);
  },

  unlockDictionary(dictionaryId) {
    return axios.post(`Nsi/Dictionary/${dictionaryId}/Unlock`);
  },

  deleteDictItem(id) {
    return axios.delete(`Nsi/Dictionary/Items/${id}`);
  },
  getDictionaryVersion(dictionaryId, date) {
    const params: AxiosRequestConfig = {
      responseType: "arraybuffer",
    };
    return axios.get(
      `Nsi/Dictionary/${dictionaryId}/Version?versionDate=${date}`,
      params,
    );
  },
  getAllItemsVersions(dictionaryId) {
    return axios.get(`Nsi/Dictionary/Version/${dictionaryId}`);
  },
  getDictinaryHistory(dictionaryId) {
    return axios.get(`Nsi/Dictionary/${dictionaryId}/History`);
  },
  importDictionary(name: string, formData: FormData) {
    return axios.post(`Nsi/SystemDictionary/${name}/import`, formData);
  },
};
